<kl-detail-filter
  (onSaveFilter)="commitSave($event)"
  (onSelectFilter)="selectFilter($event)"
  (onCommitFilter)="commitFilter()"
  (onCloseFilter)="closeFilter()"
  (onClearAll)="clearAll()"
  (onCloseAlert)="alertShow = false"
  (onDeleteFromValues)="deleteFromValues($event)"
  (onDeleteSavedFilter)="deleteSavedFilter($event)"
  [filterList]="filterList"
  [saveForm]="saveForm"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [showSavedFilters]="showSavedFilters"
  [showBottomButtons]="showBottomButtons"
  [currentFilter]="currentFilter"
  [selectedFilterValues]="selectedFilterValues"
>
  <form #filterForm="ngForm">
    <div class="filter-group" #materialStatus>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialStatus.collapsed = !materialStatus.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_status" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialStatus.collapsed,
              'fa-angle-down': !materialStatus.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!materialStatus.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          #materialStatusDropdown
          [options]="materialStatusOptions"
          name="material_status"
          [(ngModel)]="materialStatusValue"
          [style]="{ width: '90%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="filter-group" #detailFilterProductGroup>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          detailFilterProductGroup.collapsed =
            !detailFilterProductGroup.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "product_group" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': detailFilterProductGroup.collapsed,
              'fa-angle-down': !detailFilterProductGroup.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!detailFilterProductGroup.collapsed"
      >
        <p-listbox
          [multiple]="true"
          checkbox="checkbox"
          [options]="productGroupTypes"
          name="product_group"
          [(ngModel)]="productGroupValue"
          [style]="{ width: '90%' }"
        ></p-listbox>
      </div>
    </div>
    <div class="filter-group" #detailFilterPackageType>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          detailFilterPackageType.collapsed = !detailFilterPackageType.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "package_type" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': detailFilterPackageType.collapsed,
              'fa-angle-down': !detailFilterPackageType.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!detailFilterPackageType.collapsed"
      >
        <p-listbox
          [multiple]="true"
          checkbox="checkbox"
          [options]="packageTypes"
          name="package_type"
          [(ngModel)]="packageTypeValue"
          [style]="{ width: '90%' }"
        ></p-listbox>
      </div>
    </div>

    <div class="filter-group" #materialCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialCode.collapsed = !materialCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialCode.collapsed,
              'fa-angle-down': !materialCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!materialCode.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_code"
          #materialCodeDropdown
          [(ngModel)]="materialCodeExpressionValue"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="materialCodeValue"
            #materialCodeInput
            name="material_code_input"
            class="form-control form-control-sm"
            maxlength="20"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_CODE',
                  MaterialComponent,
                  false,
                  '01.02.01'
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialDescription>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialDescription.collapsed = !materialDescription.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_description" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialDescription.collapsed,
              'fa-angle-down': !materialDescription.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialDescription.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_description"
          #materialDescriptionDropdown
          [(ngModel)]="materialDescriptionExpressionValue"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="materialDescriptionValue"
            #materialDescriptionInput
            name="material_description_input"
            class="form-control form-control-sm"
            maxlength="20"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_DESCRIPTION',
                  MaterialComponent,
                  false,
                  '01.02.01'
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialSpecode1>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialSpecode1.collapsed = !materialSpecode1.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_special_code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialSpecode1.collapsed,
              'fa-angle-down': !materialSpecode1.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialSpecode1.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_specode1"
          #materialSpecodeDropdown
          [(ngModel)]="materialSpecodeExpressionValue1"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="materialSpeCodeValue1"
              #materialSpecodeInput
              name="material_specode_1_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE1',
                    MaterialSpecodeListComponent,
                    true,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialSpecode2>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialSpecode2.collapsed = !materialSpecode2.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_special_code" | translate }} 2
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialSpecode2.collapsed,
              'fa-angle-down': !materialSpecode2.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialSpecode2.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_specode_2"
          #materialSpecodeDropdown2
          [(ngModel)]="materialSpecodeExpressionValue2"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="materialSpeCodeValue2"
              #materialSpecodeInput
              name="material_specode_2_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE2',
                    MaterialSpecodeListComponent,
                    true,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialSpecode3>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialSpecode3.collapsed = !materialSpecode3.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_special_code" | translate }} 3
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialSpecode3.collapsed,
              'fa-angle-down': !materialSpecode3.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialSpecode3.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_specode_3"
          #materialSpecodeDropdown3
          [(ngModel)]="materialSpecodeExpressionValue3"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="materialSpeCodeValue3"
              #materialSpecodeInput
              name="material_specode_3_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE3',
                    MaterialSpecodeListComponent,
                    true,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialSpecode4>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialSpecode4.collapsed = !materialSpecode4.collapsed"
      >
        <p class="font-weight-light">
          {{ "material_special_code" | translate }} 4
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialSpecode4.collapsed,
              'fa-angle-down': !materialSpecode4.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialSpecode4.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_specode_4"
          #materialSpecodeDropdown4
          [(ngModel)]="materialSpecodeExpressionValue4"
          [options]="materialExpressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="form-group my-1">
          <div class="input-group" style="width: 90%">
            <input
              type="text"
              [(ngModel)]="materialSpeCodeValue4"
              #materialSpecodeInput
              name="material_specode_4_input"
              class="form-control form-control-sm"
              maxlength="20"
            />
            <div class="input-group-append">
              <span
                class="input-group-text transparent"
                (click)="
                  setModal(
                    'specode',
                    'SPECODE4',
                    MaterialSpecodeListComponent,
                    true,
                    ''
                  )
                "
              >
                <i class="fal fa-ellipsis-h"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialUser.collapsed = !materialUser.collapsed"
      >
        <p class="font-weight-light">
          {{ "recording_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialUser.collapsed,
              'fa-angle-down': !materialUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!materialUser.collapsed">
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [style]="{ width: '250px' }"
            [options]="materialUserOptions"
            [optionLabel]="'username'"
            [filter]="true"
            name="material_create_user"
            [(ngModel)]="materialUserValue"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialRecordDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialRecordDate.collapsed = !materialRecordDate.collapsed"
      >
        <p class="font-weight-light">
          {{ "record_date" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialRecordDate.collapsed,
              'fa-angle-down': !materialRecordDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialRecordDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="material_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="material_first_tate"
              id="material_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="material_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="material_last_date"
              id="material_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialLastChangedUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          materialLastChangedUser.collapsed = !materialLastChangedUser.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "last_changed_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialLastChangedUser.collapsed,
              'fa-angle-down': !materialLastChangedUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialLastChangedUser.collapsed"
      >
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [options]="materialUserOptions"
            [optionLabel]="'username'"
            [filter]="true"
            name="material_change_user"
            [(ngModel)]="materialLastChangedUserValue"
            [style]="{ width: '90%' }"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialLastChangedDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="
          materialLastChangedDate.collapsed = !materialLastChangedDate.collapsed
        "
      >
        <p class="font-weight-light">
          {{ "last_date_changed" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialLastChangedDate.collapsed,
              'fa-angle-down': !materialLastChangedDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialLastChangedDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="material_last_changed_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="material_last_changed_first_date"
              id="material_last_changed_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="material_last_changed_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="material_last_changed_last_date"
              id="material_last_changed_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-detail-filter>
